import { ASSIGNED_COLOR, SUB_MODEL, TYPE } from 'Pages/GMS/ISR/ISRConstants';
import React from 'react';
import { TFieldClass } from '../model';
import { DeleteIcon } from 'assests/GmsIcons';
import { deleteClass } from '../ModelServices/ModalServices';
import { toast } from 'Components/DesignSystem/Toast/useToast';

type TClassTable = {
    id: string;
    fieldClasses: TFieldClass[];
    modelClasses: TFieldClass[];
    selectedFilter: string;
    projectId: string;
    toggleMenu: () => void
    setSelectedClass: React.Dispatch<React.SetStateAction<TFieldClass>>;
    setRefreshCounter: React.Dispatch<React.SetStateAction<number>>;
}

const ClassTable = ({id, fieldClasses, modelClasses, selectedFilter, projectId, setRefreshCounter, setSelectedClass, toggleMenu}: TClassTable) => {

    const getTableData = ()  => {
        return selectedFilter === SUB_MODEL ? modelClasses : fieldClasses;
    }

    const deleteFieldOrModelClass = async (classId: string) => {
        try {
            const responseData = await deleteClass(projectId, classId);
            if (responseData?.done) {
                toast.success(responseData?.message);
                setRefreshCounter((prev) => prev = prev + 1);
            } else {
                toast.error(responseData?.message);
            }
        } catch (error) {
            console.log('Error', error);
        }
    }

    return (
        <div id={id} className="tw-border tw-border-solid tw-mt-3 tw-border-[#DFE0E6] tw-border-r-2 ">
            <div id={`${id}-scroll-container`} className="table-container" style={{ width: '100%', height: 'auto', overflowX: 'auto' }}>
                <table id={`${id}-table`} className="tw-bg-[#DFE1E6] tw-w-full tw-table-fixed">
                    <thead id={`${id}-header`} className="tw-sticky tw-top-0 tw-bg-[#DFE1E6]">
                            <tr>
                                <th id={`${id}-class-header`} className="table-header-style tw-w-[30%]">
                                    {'Class'}
                                </th>
                                <th id={`${id}-type-header`} className="table-header-style tw-w-[15%]" >
                                    {TYPE}
                                </th>
                                <th id={`${id}-color-header`} className="table-header-style tw-w-[30%]" >
                                    {ASSIGNED_COLOR}
                                </th>
                                <th id={`${id}-edit-header`} className="table-header-style tw-w-[10%]" >
                                </th>
                                <th id={`${id}-delete-header`} className="table-header-style tw-w-[10%]" >
                                </th>
                            </tr>
                    </thead>
                    <tbody id={`${id}-body`} className="tw-bg-white tw-divide-y tw-divide-[#F4F5F7]">
                        {getTableData()?.map((row, rowIndex) => {
                            return <tr 
                                id={`${id}-row-${rowIndex}`}
                                className={`table-item-style ${ rowIndex % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'}`}
                                key={row?.id}
                            >
                                <td id={`${id}-class-cell-${rowIndex}`}>
                                    {row?.name ?? ''}
                                </td>
                                <td id={`${id}-type-cell-${rowIndex}`}>
                                    {row?.type ?? ''}
                                </td>
                                <td id={`${id}-color-cell-${rowIndex}`}>
                                    <div 
                                        id={`${id}-color-preview-${rowIndex}`}
                                        style={{backgroundColor: row?.colour ?? ''}} 
                                        className="tw-w-8 tw-h-8 tw-rounded-sm" 
                                    />
                                </td>
                                <td id={`${id}-edit-cell-${rowIndex}`}>
                                    <button data-testid="class-classtable-button-1" 
                                        id={`${id}-edit-btn-${rowIndex}`}
                                        onClick={() => {setSelectedClass(row); toggleMenu();}} 
                                        className='tw-text-[#0747A6] tw-text-sm'
                                    >
                                        Edit
                                    </button>
                                </td>
                                <td id={`${id}-delete-cell-${rowIndex}`}>
                                    <button aria-label="Delete" data-testid="class-classtable-button-2" 
                                        id={`${id}-delete-btn-${rowIndex}`}
                                        onClick={() => deleteFieldOrModelClass(row?.id?.toString() ?? '')}
                                    >
                                        <DeleteIcon />
                                    </button>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ClassTable;